
<kendo-dialog-titlebar>
  <div style="font-size: 18px; line-height: 1.3em;">
    <span class="k-icon k-font-icon k-icon-xl k-color-error k-i-warning-triangle"></span> {{title}}
  </div>
</kendo-dialog-titlebar>

<div class="container">
  <div class="error-align">
    <h4><strong>{{content}}</strong></h4>
  </div>
</div>

<kendo-dialog-actions>
  <button *ngIf="buttonText2" kendoButton themeColor="error" (click)="proceedAction()">
    {{buttonText2}}</button>
  <button kendoButton themeColor="warning" (click)="errorClose()">
    {{buttonText}}</button>
</kendo-dialog-actions>
